import * as ROUTES from '../../config/routes';
import DealExt from '../../my-lemonade-library/model/DealExtended/DealExt';

export const getDealRoute = (tableLinkId: string, deal: DealExt): string => {
    return ROUTES.LocationHome.replace(":tableLinkKey", tableLinkId) + ROUTES.Menu + "?item=" + deal.ref;

}